import React from 'react';

export const SitePathsContext = React.createContext({});
